<template>
    <div class="event-box" :class="( index == 0 ? 'event-box-large' : '' )" @click="openUrl">
        <div class="thumb" :style="'background-image: url('+ event.attributes._thumbnail_id +')'"></div>
        <div class="content">
            <h4 class="eagle">{{ event.title }}</h4>
            <table>
                <tr v-if="event.attributes.event_date">
                    <td><i class="far fa-calendar-alt"></i></td>
                    <td>{{ event.attributes.event_date }}</td>
                </tr>
                <tr v-if="event.attributes.event_time">
                    <td><i class="far fa-clock"></i></td>
                    <td>{{ event.attributes.event_time }}</td>
                </tr>
                <tr v-if="event.attributes.event_location">
                    <td><i class="fas fa-map-marker-alt"></i></td>
                    <td>{{ event.attributes.event_location.post_title }}</td>
                </tr>
            </table>
            <div class="excerpt" v-if="index == 0">
                {{ event.excerpt }}
            </div>
            <p class="price eagle">
                {{ this.displayPrice(event.attributes._price, this.$root.currency) }}/pp
            </p>
            <!--<a :href="event.url" target="_blank" class="btn"><span></span>BOOK NOW</a>-->
            <!--@click.stop.prevent="addToCart(event.id, event.attributes._sku)"-->
            <a :href="event.url" class="add-to-cart single_add_to_cart_button btn" :class="( addedToCart ? 'added-to-cart' : ( addToCartError ? 'add-to-cart-error' : '' ) )" >
                <span></span>
                BOOK NOW
                <span class="checkmark">
                    <div class="checkmark_stem"></div>
                    <div class="checkmark_kick"></div>
                </span>
            </a>
        </div>
    </div>
</template>

<script>
    import qs from 'qs'

    export default {
        name: "EventBox",
        props: {
            event: Object,
            index: Number
        },
        data() {
            return {
                addedToCart: false,
                addToCartError: false
            }
        },
        methods: {
            openUrl() {
                this.$root.openUrl(this.event.url);
            },
            displayPrice(price, currency) {
                if('undefined' == price || !price) return '';
                if(typeof price == 'object')
                    return currency + this.parsePrice(price[0]) +' - '+ currency + this.parsePrice(price[1])
                else
                    return currency + this.parsePrice(price)
            },
            parsePrice(price) {
                return parseFloat(price).toFixed(2)
            },
            addToCart(product_id, product_sku) {
                let data = {
                    quantity: 1,
                    product_id: product_id,
                    product_sku: product_sku,
                    action: 'woocommerce_ajax_add_to_cart'
                };

                this.$axios.post(wc_add_to_cart_params.ajax_url, qs.stringify(data))
                    .then(response => {

                        if(response.status == 200) {
                            this.addedToCart = true
                            this.addToCartError = false
                            this.$root.$emit('updateCartCount', 1);
                        } else {
                            this.addedToCart = false
                            this.addToCartError = true
                        }
                        // Redirect to cart option handler
                        if(wc_add_to_cart_params.cart_redirect_after_add === 'yes') {
                            window.location = wc_add_to_cart_params.cart_url;
                            return;
                        }

                        // Dispatch event so themes can update states etc.
                        document.body.dispatchEvent(new Event( 'added_to_cart', [ response.fragments, response.cart_hash, $thisbutton ]));
                    })
                    .catch(error => {
                        console.log(error)
                    });
            },
        }
    }
</script>